var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 23
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ic-booking_svg__a",
    d: "M9.471.392H.721v5.471h8.75V.392z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B7B7B7",
    stroke: "#B2B2B2",
    strokeWidth: 0.3,
    d: "M3.029 6.472c-.567 0-1.03.46-1.03 1.029V19.58c0 .567.463 1.029 1.03 1.029h18.134a1.03 1.03 0 001.029-1.03V7.502a1.03 1.03 0 00-1.03-1.03H3.03zm18.134 15.137H3.029c-1.12 0-2.03-.91-2.03-2.03V7.502c0-1.12.91-2.03 2.03-2.03h18.134c1.119 0 2.029.91 2.029 2.03V19.58c0 1.119-.91 2.029-2.03 2.029h0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 .608)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-booking_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ic-booking_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    stroke: "#B2B2B2",
    strokeWidth: 0.3,
    d: "M1.72 4.863h6.75V2.37a.979.979 0 00-.978-.979H2.7c-.54 0-.98.44-.98.98v2.492zm7.75 1H.72V2.37C.72 1.28 1.61.391 2.7.391h4.792c1.09 0 1.979.888 1.979 1.98v3.492z",
    mask: "url(#ic-booking_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    stroke: "#B2B2B2",
    strokeWidth: 0.8,
    d: "M6.129 21.108h.5V5.971h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7B7B7",
    stroke: "#B2B2B2",
    strokeWidth: 0.8,
    d: "M16.939 21.108h.5V5.971h-.5z"
  }))));
}
export default SvgIcBooking;